/* unplugin-vue-components disabled */import script from "./Snackbar.vue?vue&type=script&setup=true&lang=js"
export * from "./Snackbar.vue?vue&type=script&setup=true&lang=js"

import "./Snackbar.vue?vue&type=style&index=0&id=1c9d3cec&lang=scss"

const __exports__ = script;

export default __exports__